// Picker identity for column sources (stage 5 plan R2). A field can exist under two sources with
// the same bare SUUID, so inside the picker a node's suuid is "<source>:<suuid>". SUUIDs never
// contain ":".
var SEPARATOR = ':';

export function qualifySuuid(source, suuid) {
  return source + SEPARATOR + suuid;
}

export function bareSuuid(qualified) {
  if (!qualified) return qualified;
  var at = qualified.indexOf(SEPARATOR);
  return at === -1 ? qualified : qualified.slice(at + 1);
}

export function sourceOfSuuid(qualified) {
  if (!qualified) return undefined;
  var at = qualified.indexOf(SEPARATOR);
  return at === -1 ? undefined : qualified.slice(0, at);
}

// One header item per group, then the group's tree with qualified suuids, flattened the way
// FormSlateViewSettings.getAvailableFieldsArray does (the shape RuleFields and the picker read).
export function buildSourceGroupFields(sourceGroups) {
  var result = [];
  (sourceGroups || []).forEach(function (group) {
    result.push({
      isShown: true,
      isSectionHeader: true,
      disable: true,
      suuid: '__section_' + group.source,
      title: group.title,
      type: '',
    });
    var copy = function (list, parent) {
      return (list || []).map(function (field) {
        var node = Object.assign({}, field, {
          suuid: qualifySuuid(group.source, field.suuid),
          isShown: true,
          parent: parent || undefined,
          parents: parent ? parent.parents.concat([parent]) : [],
        });
        result.push(node);
        if (field.children) {
          node.isShowChildren = true;
          node.children = copy(field.children, node);
        }
        return node;
      });
    };
    copy(group.fields, null);
  });
  return result;
}
